const getActualsForUserNew = ({ year, token }, { observer, actualsRepo }) => {
  actualsRepo.getActualsNew(
    { year, token },
    {
      success: (response) => {
        if (response.error) {
          observer.errorReceivingActuals()
          return
        }

        observer.receiveActuals({
          actuals: response.data
        })
      },
      failure: (e) => {
        observer.errorReceivingActuals()
      }
    }
  )
}

export default getActualsForUserNew
